import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Use Audit Status
 */
export default () => {
    const { audits, typesList } = useSelector((state) => state);
    return useMemo(() => {
        if (audits.item) {
            return typesList.auditStatus.data.find(
                (item) => item.id === audits.item.status
            );
        } else return false;
    }, [audits.item, typesList]);
};
